export default __webpack_public_path__ + "static/media/blue_bottom_arrow.9edcfd88.svg";